/*
 * Manage Testing Inventory Container
 */

import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import ManageTestingInventory from './ManageTestingInventory';

import { initialFacility } from '../../reducers/initialState';
import { IinitialState } from '../../reducers';
import { selectVisibleProductsWithInstallBasesMemoized } from '../../reducers/manageInventoryReducer';

const mapStateToProps = (state: IinitialState, ownProps: WithTranslation) => {
    const selectedFacility =
        state.facilities[state.selectedFacilityID] || initialFacility;
    const { measurementPointResultsByID } = state.measurementPointResults;

    const visibleProducts = selectVisibleProductsWithInstallBasesMemoized(
        state.manageInventory,
        measurementPointResultsByID,
        selectedFacility,
        state.manageWorkOrder,
        state.productInfo
    );

    return {
        user: state.user,
        selectedFacility,
        tableData: visibleProducts,
        selectedInstallBaseID: state.manageInventory.selectedInstallBaseID,
        bannerTitle: 'bannerTitle'
    };
};

export const ManageTestingInventoryContainer = withTranslation(
    'manageInventory'
)(connect(mapStateToProps, {})(ManageTestingInventory));
